import { Component } from '@angular/core';

@Component({
  templateUrl: './workstep-shell.component.html'
})

export class WorkstepShellComponent {}
